module.exports = __webpack_public_path__ + "static/media/bannerImage1-s.8cf91690.jpg";